import { Container,Paper } from '@mui/material';
import Ranking from './components/Ranking';

const Rankings = () => {

	return (
		<Container>
			<Paper elevation={2} sx={{padding: 2, margin: 1}}>
				<Ranking />
			</Paper>
		</Container>
	)
}

export default Rankings